export const ConstStatic = {
  TOKEN_KEY: 'MPC_TOKEN',
  USER_INFO: 'MPC_USERINFO',
  JTI: 'MPC_JTI',
  APP_INFO: 'MPC_AppInfo',
  TASK_INFO: 'MPC_taskInfo'
  // 公告类型 以及 背景颜色
};
